var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPersonsCheckIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.958,
    height: 20.008,
    viewBox: "0 0 25.958 20.008",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11462",
    "data-name": "Group 11462",
    transform: "translate(-192.34 -219.181)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29639",
    "data-name": "Path 29639",
    d: "M355.115,5016.087l2.993,3,5.431-6.963",
    transform: "translate(-145.635 -4790.082)",
    fill: "none",
    stroke: "#8f8f8f",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11459",
    "data-name": "Group 11459",
    transform: "translate(197.438 222.571)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_148",
    "data-name": "Ellipse 148",
    transform: "translate(3.076 0)",
    fill: "none",
    stroke: "#8f8f8f",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.973,
    cy: 4.194,
    rx: 3.973,
    ry: 4.194,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.973,
    cy: 4.194,
    rx: 3.473,
    ry: 3.694,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_29637",
    "data-name": "Path 29637",
    d: "M134.941,2496.286s.159-7.266,6.957-7.314,7.448,7.314,7.448,7.314",
    transform: "translate(-134.941 -2479.712)",
    fill: "none",
    stroke: "#8f8f8f",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_148-2",
    "data-name": "Ellipse 148",
    transform: "translate(192.34 219.181)",
    fill: "none",
    stroke: "#8f8f8f",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.706,
    cy: 2.856,
    rx: 2.706,
    ry: 2.856,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.706,
    cy: 2.856,
    rx: 2.206,
    ry: 2.356,
    fill: "none"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonsCheckIcon);
export default __webpack_public_path__ + "static/media/PersonsCheckIcon.1f6f3e8b43276517ee4883f3bb64b709.svg";
export { ForwardRef as ReactComponent };